import { ToastService, AlertService } from 'shared';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptor,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpClient
} from '@angular/common/http';
import { Observable, throwError, of, EMPTY } from 'rxjs';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { ROUTES_URL } from '../utils';
import { AppStoreActions } from '../store';
import { ErrorService } from '../../../../projects/shared/src/lib/services/error.service';
const DEFAULT_SERVER_ERROR_MESSAGE = 'Ocurrió un error en el servidor.';

enum PUNKU_CODE_SESSION_ERROR {
  ERROR_50001 = '50001',
  ERROR_50002 = '50002'
}

@Injectable({
  providedIn: 'root'
})
export class HttpResponseInterceptor implements HttpInterceptor {
  constructor(
    private toast: ToastService,
    private store: Store,
    private alertService: AlertService,
    private httpClient: HttpClient,
    private router: Router,
    private errorSunedu: ErrorService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        // if (event instanceof HttpResponse) {
        //   this.handleResponse(event, req);
        // }
        return event;
      }
      , (err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.store.dispatch(new AppStoreActions.Session.Logout());
            return;
          }
          if (err.status >= 400) {
            // if (err.error.messages) {
            //   this.toast.error(err.error.messages.map(x => x.msg).join(', '));
            // } else {
              this.errorSunedu.show();
              // this.toast.error('La solicitud fue rechazada.');
            // }
            return err;
          }

        }
      }),

      // catchError((error: HttpErrorResponse) => {
      //   // const needResend = this.handleErrorResponse(error);

      //   // if (!needResend) {
      //   //   return throwError(error);
      //   // } else {
      //   //   return this.handleResend(next, req);
      //   // }
      //   if (error.status == 401) {
      //     this.alertService.open('La sesión expiró').then(() => {

      //     });
      //   }
      //   return throwError(error);
      // })
    );
  }

  handleResponse = (response: HttpResponse<any>, request: HttpRequest<any>) => {
    if (
      request.responseType === 'blob' &&
      response.body.type === 'application/json'
    ) {
      this.toast.warning('Alerta: No se encontraron registros a exportar.');
      response.body.badExcel = true;
    }
  };

  handleErrorResponse = (error: HttpErrorResponse) => {
    let needResend = false;
    if (error.error instanceof ErrorEvent) {
      this.toast.error('Error al acceder al gateway');
    } else if (error instanceof HttpResponse) {
      // msg = this.buildMessageFromData(error.body);
    } else {
      if (this.UnauthorizedForToken(error)) {
        // if (!this.store.state.session.sessionExpired) {
        //   needResend = true;
        // }
      } else if (this.isUnauthorizedForPunku(error)) {
        this.handleUnauthorizedForPunku(error);
      } else {
        this.handleErrorToast(error);
      }
    }

    return needResend;
  };

  /**
   * Elimina la sesión, y el observable en AppComponent
   * redirigirá a la pantalla de login
   */
  private logoutAndRedirect = () => {
    // this.store.uiAction.setBlockUi(true);
    // this.store.sessionAction.logout();
  };

  /**
   *
   * Verifica si el error viene de la verificacion hecha en PUNKU
   */
  private isUnauthorizedForPunku = (error: HttpErrorResponse): boolean => {
    const erroresPunku = [
      PUNKU_CODE_SESSION_ERROR.ERROR_50001,
      PUNKU_CODE_SESSION_ERROR.ERROR_50002
    ];
    return (
      error.status === 401 &&
      error.error.errors &&
      error.error.errors.Code &&
      erroresPunku.includes(error.error.errors.Code)
    );
  };

  private UnauthorizedForToken = (error: HttpErrorResponse): boolean => {
    return error.status === 401 && !error.error;
  };

  private handleErrorToast = (error: HttpErrorResponse) => {
    if (error.status !== 400) {
      if (error.error && error.error.errors && error.error.errors.Message) {
        this.toast.error(error.error.errors.Message);
      } else if (error.error.messages) {
        this.toast.error(error.error.messages.join(', '));
      } else {
        this.toast.error(DEFAULT_SERVER_ERROR_MESSAGE);
      }
    }
  };

  private handleUnauthorizedForPunku = (error: HttpErrorResponse) => {
    // if (!this.store.state.session.sessionExpired) {
    //   const msg = error.error.errors
    //     ? error.error.errors.Message
    //     : 'La sesión no existe.';
    //   this.alertService.open(msg, null, { icon: 'error' }).then(() => {
    //     this.logoutAndRedirect();
    //   });
    // }

    // this.store.sessionAction.setSessionExpired();
  };

  private handleResend = (next: HttpHandler, req: HttpRequest<any>) => {
    // const url = `${this.store.state.globalConfig.configuration.punku.api.proxyUrl}`;
    // return this.httpClient
    //   .post(`${url}/api/Authorization/RefreshToken`, {})
    //   .pipe(
    //     switchMap((resp: any) => {
    //       this.store.sessionAction.setNewToken(resp.TOKEN_JWT);

    //       const headers = req.headers
    //         .set('Authorization', `Bearer ${resp.TOKEN_JWT}`)
    //         .append('Content-Type', 'application/json');

    //       const reqClone = req.clone({
    //         headers
    //       });

    //       return next.handle(reqClone);
    //     })
    //   );
  };
}
